/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .controller('FolderShareController', [
        '$scope',
        '$modalInstance',
        'element',
        'operationComplete',
        'template',
        '$q',
        'modalAction',
        '$translate',
        'RecipientType',
        'NodeMember',
        function ($scope, $modalInstance, element, operationComplete, template, $q, modalAction, $translate, RecipientType, NodeMember) {
            $scope.modal = $modalInstance.options;
            $scope.modal.footerTemplate = template('nodes/_invitation_modal_footer');
            $scope.node = $scope.element = element;

            $scope.invitation = angular.extend(new NodeMember, {
                node_uuid: $scope.node.uuid,
                can_edit: true,
                can_invite: false,
                can_view_members: false,
                expiration_date: $scope.node.expirationDate,
                allow_guest_downloads: $scope.node.allowGuestDownloads,
                message: '',
                setLanguage: function (lang) {
                    $scope.invitation.locale = lang.id;
                    $scope.invitation.language = lang.value;
                }
            });

            $scope.recipients = [];

            $scope.markReadOnly = function () {
                if ($scope.invitation.can_edit) {
                    $scope.invitation.read_only = false;
                } else {
                    $scope.invitation.read_only = true;
                    $scope.invitation.can_invite = false;
                    $scope.invitation.can_view_members = false;
                }
            };

            $scope.disableSubmit = function () {
                return !$scope.recipients || $scope.recipients.length <= 0 ||
                    ($scope.node.isCurrentUserOwner($scope.account) && angular.isUndefined($scope.invitation.expiration_date));
            };

            $scope.cancel = $scope.close = () => $modalInstance.dismiss('cancel');

            $scope.onRecipientsUpdate = (recipients) => $scope.recipients = recipients;

            $scope.ok = () => {
                $scope.modal.loading = true;

                $q.all($scope.recipients.map((recipient) => {
                        const invitation = angular.copy($scope.invitation);

                        if (recipient.type === RecipientType.GROUP) {
                            invitation.type = 'share_group'
                            invitation.holder_entity_uuid = recipient.uuid
                        } else {
                            invitation.email = recipient;
                        }

                        return invitation.$create();
                    }
                )).then(() => {
                    $translate('shared_folder_confirmation_modal_title', {folder_name: element.name})
                        .then(function (modalTitle) {
                            return modalAction(null, {
                                modalAction: 'confirmation',
                                modalType: 'notify',
                                modalTitle: modalTitle,
                                modalBodyTemplate: 'modals/actions/shared_folder_confirmation',
                                modalController: [
                                    '$scope',
                                    '$modalInstance',
                                    function ($scope, $modalInstance) {
                                        $scope.modal = $modalInstance.options;
                                        $scope.ok = $scope.close = function () {
                                            $modalInstance.close('ok');
                                        };
                                        $scope.folderName = element.name;
                                        $scope.folderLink = element.getAbsoluteUrl();
                                    }
                                ]
                            });
                        })
                        .then(() => operationComplete('shared_folder_success_message', {folder_name: element.name}));

                    $modalInstance.close('reload_nodes');
                }).finally(() => $scope.modal.loading = false);
            }

            $modalInstance.opened.then(function () {
                var clipboard = new ClipboardJS($('.invite-dialog .btn-primary').get(0), {
                    text: function () {
                        return element.getAbsoluteUrl();
                    }
                });

                $scope.$on('$destroy', function () {
                    clipboard.destroy();
                });
            });
        }]);
